import { mode } from '@chakra-ui/theme-tools';
import { spacing } from '../../tokens';

// The theme's `shadows` object is rebuilt by buildGlobalStyles() per aesthetic:
//   Classic  → rgba(16, 24, 40, ...) — cool
//   Clubhouse → rgba(44, 42, 38, ...) — warm
// By referencing `sm`, `md`, `lg`, `xl` tokens the card picks up the right tint.

const Card = {
	baseStyle: (props: any) => ({
		p: spacing.card,
		display: 'flex',
		flexDirection: 'column',
		width: '100%',
		position: 'relative',
		borderRadius: '16px',
		minWidth: '0px',
		wordWrap: 'break-word',
		bg: mode('#ffffff', 'navy.800')(props),
		backgroundClip: 'border-box',
		border: '1px solid',
		borderColor: mode('secondaryGray.100', 'rgba(255, 255, 255, 0.06)')(props),
		boxShadow: 'none',
	}),
	variants: {
		flat: (props: any) => ({
			bg: mode('#ffffff', 'navy.800')(props),
			boxShadow: 'none',
			borderColor: 'transparent',
		}),
		raised: (props: any) => ({
			bg: mode('#ffffff', 'navy.800')(props),
			boxShadow: 'md',
		}),
		floating: (props: any) => ({
			bg: mode('#ffffff', 'navy.800')(props),
			boxShadow: 'lg',
			transition: 'box-shadow 0.18s ease, transform 0.18s ease',
			_hover: {
				boxShadow: 'xl',
				transform: 'translateY(-2px)',
			},
		}),
	},
};

export const CardComponent = {
	components: {
		Card
	}
};
